<template>
  <div class="form-group" :class="{'-filled': inputValue}">
    <div class="input -required">
      <input type="text" class="form-control" :name="identifier" :id="identifier" v-model="inputValue" :class="{'-filled': inputValue}" :required="required">
      <div class="input-background">
        <label class="control-label" :for="identifier">{{label}}</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'

const props = defineProps({
    required: {
        type: Boolean,
        default: false
    },
    identifier: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    value: {
        type: [String, Number],
        default: ''
    }
})

const emit = defineEmits(['update:modelValue'])

const inputValue = computed({
  get () {
    return props.value
  },
  set (value) {
    emit('update:modelValue', value)
  }
})
</script>
